import { localDatabase, LocalEntity } from '../storage/LocalDatabase';

const FORMAT = 'pawerlifting-local-backup';
const VERSION = 1;

export async function exportLocalData(userId: string): Promise<string> {
  return JSON.stringify({ format: FORMAT, version: VERSION, exportedAt: new Date().toISOString(), entities: await localDatabase.all(userId) }, null, 2);
}

export async function importLocalData(userId: string, json: string): Promise<number> {
  const parsed = JSON.parse(json);
  if (parsed?.format !== FORMAT || parsed?.version !== VERSION || !Array.isArray(parsed.entities)) {
    throw new Error('This is not a supported PawerLifting backup file.');
  }
  const entities = parsed.entities as LocalEntity[];
  if (entities.some(entity => entity.userId !== userId)) {
    throw new Error('The backup belongs to a different user.');
  }
  for (const entity of entities) {
    await localDatabase.put(entity.type, entity.id, entity.userId, entity.value, entity.sortKey);
  }
  return entities.length;
}
